import React, { useState, useEffect, useRef} from 'react';
import '../../css/pages.css';
import language from '../../utils/LanguageSettings';
import ReactMarkdown from 'react-markdown';
import rehypeRaw from 'rehype-raw';
import gfm from 'remark-gfm';
import { fetchTermAndConditionsById, fetchTermAndConditionsTitle, fetchTermAndConditionsSEOAndGA } from '../functions/fetchLegalComplianceInformation';
import RenderSnA from '../functions/renderSnA';

const TermsAndConditions: React.FC = () => {
  const [active, setActive] = useState<string>();
  const [isSmallScreen, setIsSmallScreen] = useState(window.innerWidth <= 767);
  const [isOpen, setIsOpen] = useState(false);
  const listenerRef = useRef(null);
  const [loading, setLoading] = useState<boolean>(true);
  const [title, setTitle] = useState<string>();
  const [tabsTitle,setTabsTitle] = useState<any>();
  const [content, setContent] = useState<any>();
  const [seo, setSeo] = useState<any>(null);
  const [ga, setGa] = useState<any>(null);

   useEffect(() => {
    const fetchData = async () => {
        let data = await fetchTermAndConditionsTitle(language);
        if(data){
          setTitle(data?.attributes?.TermsConditions?.Title);
          setTabsTitle(data?.attributes?.TermsConditions?.Tabs);
          setActive(data?.attributes?.TermsConditions?.Tabs[0] ? data?.attributes?.TermsConditions?.Tabs[0].id : '');
        }
        let ga_seo_data = await fetchTermAndConditionsSEOAndGA(language);
        if(ga_seo_data){
          setSeo(ga_seo_data?.attributes?.TermsConditionsSEO || null);
          setGa(ga_seo_data?.attributes?.TermsConditionsGA || null);
        }
        setLoading(false);
    };
    fetchData();
  }, [language]);

  useEffect(() => {
    setContent('');
    const fetchData = async () => {
        if (!active) {
            return;
        }
        let data = await fetchTermAndConditionsById(language,active);
        if(data?.attributes?.TermsConditions?.Tabs[0]){
          setContent(data?.attributes?.TermsConditions?.Tabs[0].Content);
          const offsetTop = document.getElementsByClassName("main-content")[0].getBoundingClientRect().top;
          const navbar = document.getElementsByClassName("navbar")[0]?.clientHeight || 0;
          scrollTo(offsetTop-navbar, 800);
        }
    };
    fetchData();
  }, [active]);

  useEffect(() => {
    const handleResize = () => {
      setIsSmallScreen(window.innerWidth <= 480);
    };
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  useEffect(() => {
        const handleLiener = (event: any) => {
          const targetDiv = document.getElementsByClassName('select-container')[0];
          if (targetDiv && !targetDiv.contains(event.target)) {
            setIsOpen(false);
          }
        };
    
        listenerRef.current = handleLiener;
    
        if (isOpen) {
          document.addEventListener('click', handleLiener);
        } else {
          document.removeEventListener('click', handleLiener);
        }
    
        return () => {
          document.removeEventListener('click', listenerRef.current);
        };
      }, [isOpen]);


  const handlePCTitle = () => {
    return tabsTitle?.map((item, index) => {
      return <li className={item.id == active ? "active" : ""} key={index} onClick={() => click(item.id)}>{item.Title}</li>;
    });
  }
  
  const click = (id:string) => {
    const offsetTop = document.getElementsByClassName("main-content")[0].getBoundingClientRect().top;
    const navbar = document.getElementsByClassName("navbar")[0]?.clientHeight || 0;
    if(id == active){
      scrollTo(offsetTop-navbar, 800);
    }else{
      setActive(id);
      setIsOpen(false);
    }
  }

  const scrollTo = (to: number, duration: number) => {
        const start = window.scrollY;
        const change = to + start;
        let startTime = 0;
        const animateScroll = (currentTime: number) => {
            if (startTime === 0) startTime = currentTime; 
            const timeElapsed = currentTime - startTime;
            const progress = Math.min(timeElapsed / duration, 1);
            const easeInOutQuad = (progress: number) => progress < 0.5 ? 2 * progress * progress : -1 + (4 - 2 * progress) * progress;
            window.scrollTo(0, change * easeInOutQuad(progress));
            if (timeElapsed < duration) {
                requestAnimationFrame(animateScroll);
            }
        }; 
        requestAnimationFrame(animateScroll);
    };

  if (loading) {
    return (<>
        <div id="loader">
            <div className="spinner-border"></div>
        </div>
    </>
    );
  }

  return (
    <>
    <RenderSnA seo={seo} ga={ga} />
    <section id="main-content" className="pt-sm-3 pt-0 spacer-bottom page-template-tabbed-layout terms-and-conditions">
	    <div className="static-pages container-fluid" style={language == "en" ? {maxWidth:"1340px",fontFamily:"Montserrat"} : {maxWidth:"1340px",fontFamily:"Noto Sans TC"}}>
        <h1 className="my-5">{title}</h1>
        <div className="row row-sm main-content">
          <div className="col-xl-3 col-lg-4 col-md-5">
            {isSmallScreen ?
              <div className="select-container">
                  <div className="select-display" onClick={() => setIsOpen(!isOpen)}>
                      {active ? tabsTitle?.find(option => option.id === active)?.Title.length > 35 ? 
                      tabsTitle?.find(option => option.id === active)?.Title?.slice(0,31) + " ..." : tabsTitle?.find(option => option.id === active)?.Title : ""}
                  </div>
                  {isOpen && (
                      <ul className="select-options">
                      {tabsTitle?.map(option => (
                          <li
                          key={option.Title}
                          className={`select-option ${active == option.id ? 'selected' : ''}`}
                          onClick={() => click(option.id)}
                          >
                          {option.Title}
                          </li>
                      ))}
                      </ul>
                  )}
              </div>
            : <ul className="default-tab d-md-block d-none">
              {handlePCTitle()}
            </ul>
            }
          </div>
          <div className="col-xl-9 col-lg-8 col-md-7">
            <div className="tab-content pt-lg-5 pt-4 pb-lg-5 pb-0 px-lg-5 px-md-4 px-3"  style={language == "en" ? {fontFamily:"Barlow"} : {fontFamily:"Noto Sans TC"}}>
              {/* {handleContent()} */}
              <ReactMarkdown remarkPlugins={[gfm]} rehypePlugins={[rehypeRaw]}>{content}</ReactMarkdown>
            </div>
          </div>
        </div>
		  </div>
    </section>
    </>
  );
};

export default TermsAndConditions;